export const SYSTEM_IDS_BY_ACCOUNT_TYPE: Readonly<Record<string, readonly string[]>> = {
    employee: ["fms_main", "fms_api_exchange_v1", "fms_api_v3"],
    wholesale: ["fms_ws", "fms_api", "fms_api_v2", "fms_api_xml"],
    retail: ["fms_retail"],
};

export const DEFAULT_GROUP_NAMES_BY_SYSTEM: Readonly<Record<string, string>> = {
    fms_ws: "administrator",
    fms_api_v2: "api_user",
};
